export interface FooterSVGProps {
  className?: string
}

export const FooterSVG = (props: FooterSVGProps) => {
  const { className = 'fill-black' } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 1440 386" fill="none" className={className}>
      <path
        d="M0 385.999L1440 385.999V0C1231.7 132.798 984.339 209.745 719 209.745C454.51 209.745 207.878 133.289 3.36338e-05 1.27255L0 385.999Z"
        fill="currentColor"
      />
    </svg>
  )
}
